import React, { useContext, useEffect } from 'react';
import useInvalidateRouteGroup from '@Hooks/Routes/useInvalidateRouteGroup';
import useRouteGroup from '@Hooks/Routes/useRouteGroup';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { BreadcrumbContext } from '@Components/UI/Layout/Layout';
import AdminsTable from './AdminsTable';

const Admins = () => {
	const routeGroup = useRouteGroup('admins');

	const { path, url } = useRouteMatch();
	const { isCurrent, invalidatedBaseURL } = useInvalidateRouteGroup({
		mode: 'end',
		baseURL: '/dashboard/admins',
		routeGroup: routeGroup,
		routePlacement: 3,
	});
	const { removeLink } = useContext(BreadcrumbContext);
	useEffect(() => {
		if (isCurrent) {
			removeLink && removeLink('admins');
		}
	}, [isCurrent]);

	return (
		<>
			<Switch>
				{routeGroup && !Array.isArray(routeGroup) && (
					<>
						<Route exact path={url}>
							<AdminsTable />
						</Route>

						{routeGroup.routes.map((_) => {
							return (
								<Route strict path={`${path}/${_.route}`}>
									{_.component}
								</Route>
							);
						})}
					</>
				)}
			</Switch>
		</>
	);
};

export default Admins;
